// extracted by mini-css-extract-plugin
export var equalColumn = "_id-0";